import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/strategy/architecture')({
  component: () => <PageStub title="Business Architecture" description="Business model design" />,
});
